import "./MyWork.css";
import { useInView } from "react-intersection-observer";
import apiRouter from "../../utils/apiRouter.json";
import SectionTitle from "../../Components/SectionTitle";
import ProjectCard from "../../Components/ProjectCard/ProjectCard";
import FadeInSection from "../../Components/FadeInSection";
import projects from "./projects";
import importAllImages from "../../utils/imageImporter";

function MyWork(props) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <div>
      <div ref={ref}>
        <SectionTitle $animate={inView}>
          My Work
        </SectionTitle>
      </div>

      <div className="project-cards-container">
        {projects.projects.map((card, index) => {
          return (
            <FadeInSection key={card.title}
              delay={`${index * 0.2}s`}>

              <ProjectCard
                title={card.title}
                image={importAllImages()[card.image]}
                description={card.description}
                demoLink={
                  card.demoLink
                  ? `${apiRouter.api.mainRoute}${card.demoLink}`
                  : "https://colab.research.google.com/drive/1pCBSMfwWBnfLICZC1qFLe5daG9zFeHUE?usp=sharing"}
              />
            </FadeInSection>
          );
        })}
      </div>
    </div>
  );
}

export default MyWork;
